export default __webpack_public_path__ + "static/media/bakun_barangay_seal.05e1cd73.png";